import importReact from "../../utils/importReact";
import { IComments } from "../../lib/models/IComment";

export default function initComments() {
  const entrypoint: HTMLElement = document.querySelector(".comments");
  if (entrypoint) {
    import(/* webpackChunkName: "comments" */ "./Comments").then((e) => {
      const data: IComments = JSON.parse(entrypoint.dataset.comments);
      const isAuthenticated = entrypoint.dataset.isAuthenticated === "true";
      importReact().then(([React, ReactDOM]) => {
        ReactDOM.render(
          React.createElement(e.default, {
            data,
            isAuthenticated
          }),
          entrypoint
        );
      });
    });
  }
}
